import { useMemo, useCallback, useContext } from 'react';
import ReactEcharts from 'echarts-for-react';
import Head from '@/containers/chart_box/Head';
import Body from '@/containers/chart_box/Body';
import { fmtThousand } from '@/utils/comUtil';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import { sinTimeDimensionSinIndexMulValue } from '@/utils/reportResponseUtil';

// tooltip / 轴标签回调提升到模块级，保证数据不变时 option 内容可被深度比较命中，
// 避免 ReactEarts 因为回调引用变化而重复 setOption
const tooltipFormatter = (p) => {
  return `优惠券核销率:<br/> ${p[0].value}%`;
};

const axisLabelInterval = () => {
  return true;
};

const LevelDistribution = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const { charts } = themeContext[brandContext];
  const { chartsFontSize, fontFamily } = themeContext.comm;
  const { loading9, data = [], title } = props;

  // 图表数据单独抽出来缓存，标签回调依赖它才能保持引用稳定
  const chartData = useMemo(() => {
    if (!data || data.length === 0) {
      return null;
    }
    const yDataUse = [];
    const couponTotalData = [];
    const couponUsedData = [];
    const couponTotal = data.filter((item) => {
      return item.index === 'COUPON_TOTAL';
    });
    const couponUsed = data.filter((item) => {
      return item.index === 'COUPON_USED';
    });
    couponTotal.sort((a, b) => {
      return a.values[2].value - b.values[2].value;
    });
    couponUsed.sort((a, b) => {
      return a.values[2].value - b.values[2].value;
    });
    sinTimeDimensionSinIndexMulValue(couponTotal || []).forEach((e) => {
      couponTotalData.unshift(e.VALUE);
    });
    sinTimeDimensionSinIndexMulValue(couponUsed || []).forEach((e) => {
      yDataUse.unshift(e.LABEL);
      couponUsedData.unshift(e.VALUE);
    });
    const dataSource = [];
    couponUsedData.forEach((item, index) => {
      dataSource.push(`${((item / couponTotalData[index]) * 100).toFixed(2)}`);
    });
    return { yDataUse, dataSource, couponUsedData };
  }, [data]);

  const labelFormatter = useCallback(
    (p) =>
      `${fmtThousand(chartData?.couponUsedData?.[p.dataIndex])}张 ${p.value}%`,
    [chartData],
  );

  // 渲染阶段直接计算 option，图表挂载时拿到的就是完整配置，
  // 避免先挂载空 option 再由 effect 补一次而绘制两遍
  const option = useMemo(() => {
    if (!chartData) {
      return null;
    }
    const { yDataUse, dataSource } = chartData;

    return {
      textStyle: {
        fontSize: chartsFontSize.s03,
        fontFamily: fontFamily,
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        textStyle: {
          fontSize: chartsFontSize.s03,
        },
        formatter: tooltipFormatter,
      },
      // barWidth: 20,
      barCategoryGap: '50%',
      grid: {
        top: 10,
        left: 10,
        right: 10,
        bottom: -20,
        containLabel: true,
      },
      xAxis: {
        show: false,
        type: 'value',
        // boundaryGap: [0, 0.01],
        axisTick: true,
        axisLine: true,
        splitLine: {
          show: false,
        },
        max: 100,
      },
      yAxis: {
        // name: formatMessage({ id: 'comm.unit.lbl03' }),
        nameGap: 5,
        nameTextStyle: {
          color: charts.yColor,
          // padding: [0, 20, 0, 0],
        },
        // boundaryGap: [0, 0.3],
        type: 'category',
        data: yDataUse, // ['银卡会员', '银卡会员', '银卡会员', '银卡会员'],
        axisTick: true,
        axisLine: true,
        axisLabel: {
          textStyle: {
            color: '#333', //坐标值得具体的颜色
            fontSize: chartsFontSize.s03,
          },
          interval: axisLabelInterval,
        },
        splitLine: {
          show: false,
        },
      },
      color: charts.barColorList,
      // series: seriesData,
      series: [
        {
          data: dataSource,
          type: 'bar',
          barWidth: '50%',
          barMinHeight: 80,
          showBackground: true,
          backgroundStyle: {
            color: '#83D0EF',
          },
          itemStyle: {
            normal: {
              label: {
                show: true,
                offset: [5, 0],
                position: 'insideRight',
                formatter: labelFormatter,
              },
            },
          },
        },
      ],
    };
  }, [
    chartData,
    charts.barColorList,
    charts.yColor,
    chartsFontSize.s03,
    fontFamily,
    labelFormatter,
  ]);

  return (
    <>
      <Head boxId={title}></Head>
      <Body bizData={data} loading={loading9}>
        {option && (
          <ReactEcharts
            style={{ width: '100%', height: '100%' }}
            option={option}
            notMerge={true}
            lazyUpdate={true}
          />
        )}
      </Body>
    </>
  );
};
export default LevelDistribution;
